import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import RequestTabel from "./loanPage";
import RegisterPage from "../register/registerPage";
import RequestDetail from "../../pages/detail/detailPage";
import RequestFindDetail from "../../pages/detail/detailFindPage";
import Wellcome from "./welcome";
import LoanRegPage from "./loanRegPage";
import { useQueryClient } from "react-query";
import { WORK_FLOW_TYPE } from "../../config/cacheKey";
import LoanFindPage from "./findPage/loanFindPage";
import LoanFindReqPage from "./findPage/loanFindReqPage";
import LoanRegBySuppPage from "./loanRegBySuppPage";
import printComponent from "../detail/tabs/printComponent";
import SupplierRequirmentsPage from "./supplierRequirmentsPage";
import suppliersRequirementsDetail from "../detail/suppliersRequirementsDetail";
import SaleSettlement from "../supplierSettelments/saleSettlement";

export default function LoanConfigPage() {
  const active = localStorage.getItem("setActivePage");
  return (
    <Switch>
      {
        /* Redirect from eCommerce root URL to /customers */
        <Redirect exact={true} from="/loan" to={`/loan/${active}`} />
      }
      <ContentRoute
        path="/loan/SupplierSettlementCartable"
        component={RequestTabel}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/loan/CustomerRegistration"
        component={LoanRegPage}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/loan/LoanRegistrationBySupplier"
        component={LoanRegBySuppPage}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/loan/SupplierRequirements"
        component={SupplierRequirmentsPage}
        label={undefined}
        children={undefined}
        render={undefined}
      />

      <ContentRoute
        path="/loan/Register"
        component={RegisterPage}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        //path="/loan-detail/:id"
        // path="/loan/loan-detail/:customerNationalCode/:loanRequestId"
        path="/loan/:activePage1/loan-detail"
        component={RequestDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        //path="/loan-detail/:id"
        // path="/loan/loan-detail/:customerNationalCode/:loanRequestId"
        path="/loan/:activePage1/loan-detail-find"
        component={RequestFindDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        //path="/loan-detail/:id"
        // path="/loan/loan-detail/:customerNationalCode/:loanRequestId"
        path="/loan/:activePage1/requirment-detail"
        component={suppliersRequirementsDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        //path="/loan-detail/:id"
        // path="/loan/loan-detail/:customerNationalCode/:loanRequestId"
        path="/loan/printPreview"
        component={printComponent}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/loan/SaleSettlement"
        component={SaleSettlement}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
